import { ComposedTheme } from '@glu/theming';

export default ({ palette }: ComposedTheme) => ({
  content: {
    backgroundColor: {
      // @theming labelText: Content Background Color, type: color
      defaultBackgroundColor: palette.background,
    },
    color: {
      // @theming labelText: Title Color, type: color, backgroundColor: popover.content.backgroundColor.defaultBackgroundColor
      negativeColor: palette.text.dark,
      // @Unused property - Will be removed in GLU-7500
      positiveColor: palette.text.light,
    },
    // @theming labelText: Content Line Height, type: pixel
    lineHeight: '26px',
  },
  // @theming labelText: Border, type: string
  border: 'none',
  // @theming labelText: Border Radius, type: pixel
  borderRadius: 2,
  // @theming labelText: Box Shadow, type: string
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
  // @Unused property - Will be removed in GLU-7500
  colorLabel: palette.text.midGray,
  // @theming labelText: Font Size, type: pixel
  fontSize: 16,
  title: {
    // @theming labelText: Title Text Transform, type: string
    textTransform: 'uppercase',
    backgroundColor: undefined,
    borderRadius: undefined,
    margin: undefined,
    padding: undefined,
  },
});
